"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.totalAmount = exports.toPercent = exports.toDollar = exports.filterOffers = exports.convertToFloat = exports.bemClass = void 0;
var _uiMoney = _interopRequireDefault(require("ui-money"));
var toDollar = exports.toDollar = function toDollar(number) {
  return new _uiMoney.default(number, 'USD').format(0);
};
var toPercent = exports.toPercent = function toPercent(number) {
  return "".concat((number * 100).toFixed(2), "%");
};

/*
  Converts string numbers to float.
  e.g. '5,000' -> 5000.
  Unfortunately, parseFloat and `+` do not work for strings with comma.
*/
var convertToFloat = exports.convertToFloat = function convertToFloat(numString) {
  return typeof numString === 'number' ? numString : parseFloat(numString.replace(/,/g, ''));
};
var totalAmount = exports.totalAmount = function totalAmount(fields) {
  return fields.reduce(function (acc, _ref) {
    var payeeAmount = _ref.payeeAmount;
    return acc + convertToFloat(String(payeeAmount));
  }, 0);
};
var filterOffers = exports.filterOffers = function filterOffers(offers, type) {
  return offers.filter(function (_ref2) {
    var product = _ref2.product;
    return product === type;
  }) || [];
};
var bemClass = exports.bemClass = function bemClass(blockClass) {
  return function () {
    for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
      names[_key] = arguments[_key];
    }
    return names.filter(Boolean).map(function (name) {
      return "".concat(blockClass, "__").concat(name);
    }).join(' ');
  };
};
